import { createIconComponent } from '../../factory/create-icon-component';
export const EuroIcon = createIconComponent(
  'EuroIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28291)">
      <path d="M23 5H1V20H23V5Z" fill="#0052B4" />
      <path
        d="M11.9998 8.28107L12.2193 8.97166H12.9293L12.3549 9.3985L12.5743 10.0891L11.9998 9.6623L11.4254 10.0891L11.6448 9.3985L11.0704 8.97166H11.7804L11.9998 8.28107Z"
        fill="#FFDA44"
      />
      <path
        d="M9.08308 9.51666L9.71571 9.84629L10.2178 9.33289L10.1066 10.0501L10.7393 10.3797L10.038 10.4933L9.92694 11.2106L9.60459 10.5636L8.90338 10.6771L9.40543 10.1637L9.08308 9.51666Z"
        fill="#FFDA44"
      />
      <path
        d="M7.875 12.4998L8.55025 12.2754L8.5503 11.5493L8.96757 12.1368L9.64286 11.9124L9.22551 12.4998L9.64286 13.0873L8.96757 12.8629L8.5503 13.4503V12.7242L7.875 12.4998Z"
        fill="#FFDA44"
      />
      <path
        d="M9.08308 15.4828L9.40534 14.8358L8.90338 14.3223L9.60467 14.4359L9.92694 13.7889L10.038 14.5062L10.7393 14.6197L10.1067 14.9494L10.2178 15.6665L9.71571 15.1531L9.08308 15.4828Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9998 16.7185L11.7804 16.0279H11.0704L11.6449 15.6011L11.4254 14.9105L11.9998 15.3373L12.5743 14.9105L12.3549 15.6011L12.9293 16.0279H12.2192L11.9998 16.7185Z"
        fill="#FFDA44"
      />
      <path
        d="M14.9166 15.4828L14.284 15.1532L13.7819 15.6666L13.893 14.9493L13.2604 14.6197L13.9616 14.5062L14.0727 13.7889L14.3951 14.4359L15.0963 14.3223L14.5942 14.8358L14.9166 15.4828Z"
        fill="#FFDA44"
      />
      <path
        d="M16.1254 12.4998L15.4502 12.7242V13.4503L15.0328 12.8628L14.3575 13.0873L14.7749 12.4998L14.3575 11.9124L15.0328 12.1367L15.4501 11.5493L15.4502 12.2755L16.1254 12.4998Z"
        fill="#FFDA44"
      />
      <path
        d="M14.9166 9.51666L14.5943 10.1637L15.0963 10.6771L14.395 10.5635L14.0727 11.2105L13.9616 10.4933L13.2604 10.3797L13.893 10.0501L13.7819 9.33289L14.284 9.84634L14.9166 9.51666Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28291">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
